<ng-container *ngIf="data$ | async as data">
    <div class="boxLoading" *ngIf="data.visible">
        <app-hub-logo-loader></app-hub-logo-loader>
    </div>
</ng-container>
